export enum ValidateLicense24IdCheckOption {
    On,
    Optional,
    Off
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/instance/models/validate-license-24idcheck-option.ts